import { queryClient } from "../../providers/QueryProvider";
import { entityCache } from "./index";

export const ownerDataQueryKey = (
  customerId: string,
  entityId: string,
  key: string
): [string, string, string, string] => [
  "entity-owner-data",
  customerId,
  entityId,
  key,
];

export const ownerDataCacheKey = (
  customerId: string,
  entityId: string,
  key: string
) => `entity_data_${customerId}_${entityId}_${key}`;

/** Forgets both copies `useGetEntityOwnerData` reads, once the owner's data has changed. */
export const forgetOwnerData = (
  customerId: string,
  entityId: string,
  key: string
) => {
  entityCache.delete(ownerDataCacheKey(customerId, entityId, key));
  queryClient.invalidateQueries(ownerDataQueryKey(customerId, entityId, key));
};
